import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import Links from './Links';

import { Container, Content, Input } from './styles';

class Filter extends Component {
  state = {
    orderBy: ['Mais recentes', 'Mais antigos'],
    selected: new Map(),
    startDate: '',
    endDate: '',
    startDateError: false,
    endDateError: false,
    startDateFocus: false,
    endDateFocus: false,
  }

  onMount = (value) => {
    if (value.type === 'item') {
      if (value.selected) {
        this.setState({ selected: value.selected });
      } else {
        const selected = new Map();
        selected.set(0, !selected.get(0));

        this.setState({ selected });
      }
    } else {
      this.setState({
        startDate: value.startDate,
        endDate: value.endDate,
      });
    }
  }

  onPressItem = (item, id) => {
    const selected = new Map();
    selected.set(id, !selected.get(id));

    this.setState({ selected });

    this.props.handleFilter({
      type: 'item',
      selected,
      value: item,
    });
  };

  FilterByDate = async () => {
    await this.validateInputs();

    const {
      startDate,
      endDate,
      startDateError,
      endDateError,
    } = this.state;

    if (!startDateError && !endDateError) {
      this.props.handleFilter({
        type: 'date',
        startDate,
        endDate,
        value: 'Data',
      });
    }
  }

  validateInputs = () => {
    this.setState({
      startDateError: false,
      endDateError: false,
    });

    const { startDate, endDate } = this.state;

    const date = new Date();
    let initialDate;
    let finalDate;

    if (startDate.length === 10) {
      const initialDay = startDate.substr(0, 2);
      const initialMonth = startDate.substr(3, 2) - 1;
      const initialYear = startDate.substr(6, 4);
      initialDate = new Date(initialYear, initialMonth, initialDay);

      if (initialMonth === 3 || initialMonth === 5 || initialMonth === 8 || initialMonth === 10) {
        if (initialDay > 30) this.setState({ startDateError: true });
      } else if (initialMonth === 1 && initialDay > 29) {
        this.setState({ startDateError: true });
      } else if (initialDay > 31) this.setState({ startDateError: true });

      if (initialMonth > 11) this.setState({ startDateError: true });
      if (initialYear > date.getFullYear()) this.setState({ startDateError: true });
      if (initialDate > date) this.setState({ startDateError: true });
    } else {
      this.setState({ startDateError: true });
    }

    if (endDate.length === 10) {
      const finalDay = endDate.substr(0, 2);
      const finalMonth = endDate.substr(3, 2) - 1;
      const finalYear = endDate.substr(6, 4);
      finalDate = new Date(finalYear, finalMonth, finalDay);

      if (finalMonth === 3 || finalMonth === 5 || finalMonth === 8 || finalMonth === 10) {
        if (finalDay > 30) this.setState({ endDateError: true });
      } else if (finalMonth === 1 && finalDay > 29) {
        this.setState({ endDateError: true });
      } else if (finalDay > 31) this.setState({ endDateError: true });

      if (finalMonth > 11) this.setState({ endDateError: true });
      if (finalYear > date.getFullYear()) this.setState({ endDateError: true });
      if (finalDate > date) this.setState({ endDateError: true });
    } else {
      this.setState({ endDateError: true });
    }

    if (initialDate > finalDate) this.setState({ startDateError: true });
  }

  handleInputChange = (label, value) => {
    this.setState({ [label]: value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      orderBy,
      startDate,
      endDate,
      startDateError,
      endDateError,
      startDateFocus,
      endDateFocus,
    } = this.state;

    return (
      <Container id="filter" orderPadding={this.props.orderPadding} ratingPadding={this.props.ratingPadding}>
        <Content>
          <ul className="links">
            {orderBy.map((item, index) => (
              <Links
                key={index.toString()}
                id={index}
                item={item}
                onPressItem={this.onPressItem}
                selected={!!this.state.selected.get(index)}
              />
            ))}
          </ul>
          <div className="date-container">
            <p>Filtrar por data</p>
            <div className="row">
              <InputMask
                mask="99/99/9999"
                maskChar={null}
                value={startDate}
                onFocusInput={startDateFocus}
                onChange={e => this.handleInputChange('startDate', e.target.value)}
                onFocus={() => this.onFocus('startDateFocus')}
                onBlur={() => this.onBlur('startDateFocus')}
              >
                {inputProps => (
                  <Input
                    {...inputProps}
                    type="text"
                    placeholder="Data inicial"
                    size="10"
                    error={startDateError}
                  />
                )}
              </InputMask>
              <InputMask
                mask="99/99/9999"
                maskChar={null}
                value={endDate}
                onFocusInput={endDateFocus}
                onChange={e => this.handleInputChange('endDate', e.target.value)}
                onFocus={() => this.onFocus('endDateFocus')}
                onBlur={() => this.onBlur('endDateFocus')}
              >
                {inputProps => (
                  <Input
                    {...inputProps}
                    type="text"
                    placeholder="Data final"
                    size="10"
                    error={endDateError}
                  />
                )}
              </InputMask>
            </div>
            <button type="button" onClick={this.FilterByDate}>Filtrar</button>
          </div>
        </Content>
      </Container>
    );
  }
}

export default Filter;
